module.exports = __webpack_public_path__ + "img/数据清洗.f5e26342.svg";